import React from 'react'
const image_host = (process.env.NODE_ENV == 'production' && '/images/') || 'https://admin.perfectsen.se/images/'
// const image_host = 'http://localhost:8010/'

export const ProductImage = (props) => {
    const { image_array, size, ...rest } = props
    const image = image_array.find((im) => im.size === size) || {}
    return <Image alt={props.label || ''} src={image.url} {...rest} />
}

const Image = (props) => {
    !props.src && console.log({ props })
    const path = (props.path && ((props.path.substring(props.path.length - 1) === '/' && props.path) || props.path + '/')) || ''
    let src = (props.src?.substring(0, 4) === 'http' && props.src) || (props.image_host || image_host) + path + props.src
    if (props.resize) {
        const { format = 'contain', width, height = width } = props.resize
        const verb = format === 'contain' ? 'f' : 'f'
        src =
            src.substring(0, src.lastIndexOf('/')) +
            '/r' +
            src.substring(src.lastIndexOf('/'), src.lastIndexOf('-')) +
            ('.' + verb + '.' + width + 'x' + height + '.') +
            src.substring(src.lastIndexOf('-'))
        src = src.replace(image_host, 'https://api.perfectsen.se/images/')
    }
    return (
        <img
            className={((props.className && props.className + ' ') || '') + 'img-fluid'}
            src={src}
            alt={props.alt}
            onDragStart={props.onDragStart || ((e) => e.preventDefault())}
            onDrop={props.onDrop || undefined}
            style={props.style || undefined}
        />
    )
}

export default Image
